import { Button } from 'reactstrap';
import styled from 'styled-components';

export const GoBackButton = styled(Button).attrs({
  className: 'btn btn-secondry',
  type: 'button'
})`
  margin-top: 60px;
`;



// WEBPACK FOOTER //
// ./src/components/pages/AccessDenied/AccessDenied.style.js